/**
 * Created by: avinersan
 * Date: 26.06.2015
 */

TS.ns('TS.UI');

(function ($, toast, undefined) {
    'use strict';

    var defaults,
        notify,
        format,
        toastOptions,
        logToConsole = false,
        logToUI = false,
        log = function (msg) {
            if (!logToConsole)
                return;
            if (logToUI)
                TS.Log.showInUI = true;
            TS.log('[tsSessionStateNotify]: ' + msg);
        };

    format = function (value) {
        var args = arguments;
        return value.replace(/\{\{|\}\}|\{(\d+)\}/g, function (m, n) {
            if (m === "{{") {
                return "{";
            }
            if (m === "}}") {
                return "}";
            }
            return args[parseInt(n) + 1];
        });
    };

    defaults = {
        warningDisplayTimeoutInSeconds: 2000,
        sessionTimeoutInSeconds: 0,
        checkSessionStateUrl: null,
        extendSessionUrl: null,
        warnWhenReachingSeconds: 0,
        showWhenSessionEnded: true,
        testBeforeWarn: true,
        checkServerBeforeWarn: true,
        checkServerBeforeTimeout: true,
        timerMarginInMs: 1000, // used when displaying time and creating timed methods to fix the lost time between the request and the js call
        whenInWarningCheckSessionStateIntervalInSeconds: 4,
        sessionWarnTitle: 'Session Timeout Warning',
        sessionWarnMessage: 'The session will timeout in {0} seconds',
        sessionEndTitle: 'aaa',
        sessionEndMessage: 'The session ended!',
        extendSessionBtnText: 'Extend',
        sessionEndGoToLinkHref: null,
        sessionEndGoToLinkText: null,
        blockInterfaceOnSessionEnd: false,
        kendoWindow: '<div tabindex="0"><span class="text" /><br /><span class="link" /></div>',
        kendoWindowCssClass: "session-timeout-window"
    };

    toastOptions = {
        "closeButton": true,
        "debug": false,
        "progressBar": false,
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": 0,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
        "tapToDismiss": false
    };

    notify = new Class({
        initialize: function (options) {
            var me = this;

            me.options = $.extend({}, defaults, options);
            me.sessionEnded = false;
            me.setInitDate();
            me.setSessionEvents();
            me.watchRequests();
        },

        setInitDate: function () {
            var me = this,
                o = me.options;
            me.initDate = new Date(new Date().getTime() - o.timerMarginInMs);
        },

        setSessionEvents: function () {
            log('Setting session events');

            var me = this,
                o = me.options,
                timeout = me.remainingTime(),
                warnBefore = o.warnWhenReachingSeconds,
                showWarnAfterMs = (timeout - warnBefore) * 1000,
                showEndAfterMs = timeout * 1000;

            if (showWarnAfterMs <= 0)
                showWarnAfterMs = 1;

            if (showEndAfterMs <= 0) {
                showEndAfterMs = 1;
                showWarnAfterMs = 0;
            }

            me.clearSessionWarnEvents();
            me.clearSessionEndEvents();

            if (showWarnAfterMs > 0)
                me.showSessionWarnTimeout = setTimeout(function () { me.showSessionWarn() }, showWarnAfterMs);
            me.showSessionEndedTimeout = setTimeout(function () { me.showSessionEnded() }, showEndAfterMs);
        },

        clearSessionEndEvents: function () {
            log('Clearing session end events');

            var me = this;
            if (me.showSessionEndedTimeout)
                clearTimeout(me.showSessionEndedTimeout);
        },

        clearSessionWarnEvents: function () {
            log('Clearing session warn events');

            var me = this;
            if (me.showSessionWarnTimeout) {
                clearTimeout(me.showSessionWarnTimeout);
                me.showSessionWarnTimeout = null;
            }
            if (me.warnToast) {
                toast.clear(me.warnToast, { force: true });
                me.warnToast = null;
            }
            if (me.sessionTimerInterval) {
                clearInterval(me.sessionTimerInterval);
                me.sessionTimerInterval = null;
            }
            if (me.sessionCheckInterval) {
                clearInterval(me.sessionCheckInterval);
                me.sessionCheckInterval = null;
            }
        },

        remainingTime: function (timeoutInSeconds) {
            var me = this,
                o = me.options,
                elapsedMs = new Date().getTime() - me.initDate.getTime(),
                result = Math.round((o.sessionTimeoutInSeconds * 1000 - elapsedMs) / 1000);

            if (result < 0)
                result = 0;
            if (timeoutInSeconds == undefined)
                return result;

            // the value is update from a server call
            if (me.sessionEnded)
                return false;

            var diff = timeoutInSeconds - result;

            if (diff > 1 || diff < -1) {
                me.initDate = new Date(me.initDate.getTime() + diff * 1000);
                return true;
            }
            return false;
        },

        showSessionWarn: function () {
            var me = this,
                o = me.options,
                timerSpanId = "sessionStateTimeoutTimer",
                timerSpan = '<span id="' + timerSpanId + '" >' + me.remainingTime() + '</span>',
                message = format(o.sessionWarnMessage, timerSpan),
                title = o.sessionWarnTitle,
                remainingTime = me.remainingTime() * 1000,
                options = $.extend({}, toastOptions, {
                    "progressBar": true,
                    "timeOut": remainingTime,
                    "onHidden": function () {
                        if (me.avoidClearSessionWarnEvents)
                            me.avoidClearSessionWarnEvents = false;
                        else
                            me.clearSessionWarnEvents();
                    }
                });

            if (o.warningDisplayTimeoutInSeconds != undefined && o.warningDisplayTimeoutInSeconds > 0) {
                options.timeOut = Math.min(options.timeOut, o.warningDisplayTimeoutInSeconds * 1000);
            }

            if (o.extendSessionUrl) {
                message += '<br />';
                message += '<button class="btn btn-xs" id="btnSessionExtend" type="button" >' + o.extendSessionBtnText + '</button>';
            }

            var exec = function () {
                me.clearSessionWarnEvents();

                log('Show session warn');

                me.warnToast = toast.warning(message, title, options);
                me.sessionTimerInterval = setInterval(function () {
                    $('#' + timerSpanId).text(me.remainingTime());
                }, 1000);

                if (o.whenInWarningCheckSessionStateIntervalInSeconds) {
                    me.sessionCheckInterval = setInterval(function () {
                        me.checkServerSessionState();
                    }, o.whenInWarningCheckSessionStateIntervalInSeconds * 1000);
                }

                if (o.extendSessionUrl) {
                    me.warnToast.delegate('#btnSessionExtend', 'click', function (e) {
                        log('Extending session');
                        me.avoidClearSessionWarnEvents = true;
                        $.ajax({ url: o.extendSessionUrl, cache: false });
                        $(e.target).attr('disabled', 'disabled');
                    });
                }
            };

            if (o.checkServerBeforeWarn) {
                me.checkServerSessionState(exec);
            } else {
                exec.call(me);
            }
        },

        showSessionEnded: function () {
            var me = this,
                o = me.options,
                message = o.sessionEndMessage,
                title = o.sessionEndTitle,
                options = $.extend({}, toastOptions, {
                    "onHidden": function () { me.clearSessionEndEvents(); }
                }),
                windowContent,
                window;

            if (me.sessionEnded) {
                throw new Error('Invalid call to showSessionEnded. The session has already ended!');
            }

            me.clearSessionWarnEvents();
            me.sessionEnded = true;
            log('Show session ended');

            var exec = function () {
                if (o.blockInterfaceOnSessionEnd && o.sessionEndGoToLinkHref) {
                    windowContent = $(o.kendoWindow).kendoWindow({
                        appendTo: $('body'),

                        width: 200,
                        height: 100,

                        modal: true,
                        resizable: true,
                        draggable: true,
                        title: title,
                        visible: false,
                        actions: []
                    });
                    windowContent.find('.text').text(message);
                    $('<a />').attr('href', o.sessionEndGoToLinkHref).text(o.sessionEndGoToLinkText).appendTo(windowContent.find('.link'));
                    window = windowContent.parent('.k-window');
                    window.addClass(o.kendoWindowCssClass);
                    window.css('z-index', 2147483647);
                    if (!title) {
                        window.find('.k-header').hide();
                        window.css('padding-top', 0);
                    }
                    windowContent.data('kendoWindow').center().open();
                } else {
                    me.endToast = toast.error(message, title, options);
                }
            };

            if (o.checkServerBeforeTimeout) {
                me.checkServerSessionState(function () {
                	me.serverSessionExpired(exec);
                });
            } else {
                exec.call(me);
            }
        },

        serverSessionExpired: function (callback) {
        	var me = this,
			   o = me.options;

        	me.internalAjaxCheck = true;
        	$.ajax({ url: o.sessionExpiredUrl, cache: false })
                .done(function (data) {                	
                	if (callback)
                		callback.call(me);
                });
        },

        checkServerSessionState: function (callback) {
            var me = this,
                o = me.options;

            me.internalAjaxCheck = true;
            $.ajax({ url: o.checkSessionStateUrl, cache: false })
                .done(function (data) {
                    // we check the session state on the server
                    // if the session state changed on the server (request from other tab) we do not execute the callback method
                    // and reset the session timer events
                    // if the session state did not change we execute the callback
                    if (data != undefined && data.TimeoutInSeconds != undefined) {
                        if (me.remainingTime(data.TimeoutInSeconds)) {
                            me.setSessionEvents();
                            return;
                        }
                    }
                    if (callback)
                        callback.call(me);
                });
        },

        watchRequests: function () {
            var me = this;

            $(document).ajaxComplete(function () {
                if (me.sessionEnded)
                    return;
                if (me.internalAjaxCheck === true) {
                    me.internalAjaxCheck = false;
                } else {
                    me.setInitDate();
                    me.setSessionEvents();
                }
            });
        }
    });

    TS.UI.SessionStateNotify = notify;
})(jQuery, toastr);